export default __webpack_public_path__ + "static/media/main.0da4a5c1.svg";